export const meta_constant = {
  home: {
    title: "Home",
    description: "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
    keywords: ["word1", "word2", "word3"],
  },
  policy: {
    title: "Policy",
    description: "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
    keywords: ["word1", "word2", "word3"],
  },
  monster: {
    title: "Monster",
    description: "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
    keywords: ["word1", "word2", "word3"],
  },
  legions: {
    title: "Legions",
    description: "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
    keywords: ["word1", "word2", "word3"],
  },
  createlegions: {
    title: "CreateLegions",
    description: "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
    keywords: ["word1", "word2", "word3"],
  },
  beasts: {
    title: "Beasts",
    description: "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
    keywords: ["word1", "word2", "word3"],
  },
  profile: {
    title: "Profile",
    description: "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
    keywords: ["word1", "word2", "word3"],
  },
  warriors: {
    title: "Warriors",
    description: "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
    keywords: ["word1", "word2", "word3"],
  },
  help: {
    title: "Help",
    description: "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
    keywords: ["word1", "word2", "word3"],
  },
  updatelegions: {
    title: "UpdateLegions",
    description: "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
    keywords: ["word1", "word2", "word3"],
  },
};

export const createlegions = {
  main: {
    maxAvailableDragCount: 10,
    maxAvailableAP: 20000,
    minAvailableAP: 2000,
  },
};

export const allConstants = {
  minHunterAP: 2000,
  maxHunterAP: 300000,
  listOfMonsterAP: [
    2000, 5000, 8000, 10000, 13000, 17000, 20000, 22000, 25000, 28000, 31000,
    34000, 37000, 40000, 42000, 47000, 50000, 53000, 56000, 60000, 250000,
    300000,
  ],
};
